import React from "react";
import { useLoaderData } from "react-router-dom";

import Animation from "@areas/shared/components/chooseLayout/Animation";
import animationStyles from "@areas/shared/components/chooseLayout/styles/animations.module.css";

import About from "./blocks/About";
import Addition from "./blocks/Addition";

function Page(props) {
  const data = useLoaderData();

  return (
    <div style={{ minHeight: "100vh" }}>
      <Animation
        animationIn={animationStyles.swipeLeftIn}
        animationOut={animationStyles.swipeRightOut}
      >
        <About data={data} />
        <Addition data={data} />
      </Animation>
    </div>
  );
}

export default Page;
